import appnexusoutstream from "./appnexusoutstream";

export default class gpsoutstream extends appnexusoutstream {
	protected get bidderName(): string {
		return 'gps';
	}
}
